/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ServiceAreaAndType
 */
export interface ServiceAreaAndType {
  /**
   *
   * @type {Array<string>}
   * @memberof ServiceAreaAndType
   */
  serviceTypes: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ServiceAreaAndType
   */
  serviceArea: string;
}

/**
 * Check if a given object implements the ServiceAreaAndType interface.
 */
export function instanceOfServiceAreaAndType(
  value: object,
): value is ServiceAreaAndType {
  if (!("serviceTypes" in value) || value["serviceTypes"] === undefined)
    return false;
  if (!("serviceArea" in value) || value["serviceArea"] === undefined)
    return false;
  return true;
}

export function ServiceAreaAndTypeFromJSON(json: any): ServiceAreaAndType {
  return ServiceAreaAndTypeFromJSONTyped(json, false);
}

export function ServiceAreaAndTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceAreaAndType {
  if (json == null) {
    return json;
  }
  return {
    serviceTypes: json["serviceTypes"],
    serviceArea: json["serviceArea"],
  };
}

export function ServiceAreaAndTypeToJSON(json: any): ServiceAreaAndType {
  return ServiceAreaAndTypeToJSONTyped(json, false);
}

export function ServiceAreaAndTypeToJSONTyped(
  value?: ServiceAreaAndType | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    serviceTypes: value["serviceTypes"],
    serviceArea: value["serviceArea"],
  };
}
